module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921071151_T.53380caa.jpg";